import { useStaticData } from '@mc/static-data-react'
import { type CertsValue, toCertsValue } from '../constants'

/**
 * Where on the certificates funnel this visitor arrived, per the param on the
 * URL — `quiz` from the interstitial, `preselected` from an off-site campaign
 * link, `added`/`declined` when they came back from the payment step.
 *
 * Resolved server-side from the request's query so it is known on the first
 * render. Three states, and callers must keep them apart: `undefined` when the
 * page supplies no value, `null` for a visitor outside the funnel. Reading
 * `undefined` as "no" would admit a visitor the page never vouched for.
 */
export const useCertsQuizIntent = () => {
  const { certsValue } = useStaticData<{ certsValue?: CertsValue | null }>()

  return {
    certsValue: certsValue === undefined ? undefined : toCertsValue(certsValue),
  }
}
